import NProgress from "nprogress"
import "nprogress/nprogress.css"

NProgress.configure({ showSpinner: false })

export default {
  data: () => ({
    isLoading: false
  }),

  beforeDestroy() {
    NProgress.done()
  },

  watch: {
    isLoading: {
      handler() {
        if (this.isLoading) {
          NProgress.start()
        } else {
          NProgress.done()
        }
      }
    }
  }
}
